import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Disc3 } from 'lucide-react';
import { ProfileDropdown } from '@/components/ProfileDropdown';
import { LibrarySheet } from '@/components/LibrarySheet';
import { LoginArea } from '@/components/auth/LoginArea';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface HeaderProps {
  onUploadClick?: () => void;
}

export function Header({ onUploadClick }: HeaderProps) {
  const { user } = useCurrentUser();

  return (
    <header className="sticky top-0 z-40 glass border-b border-white/5">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <motion.div whileHover={{ rotate: 180 }} transition={{ duration: 0.5 }}>
              <Disc3 className="h-7 w-7 text-primary" />
            </motion.div>
            <span className="text-lg font-bold hidden sm:block">Cove</span>
          </Link>

          {/* Actions */}
          <div className="flex items-center gap-2">
            {user && <LibrarySheet />}
            {user ? (
              <ProfileDropdown 
                onUploadClick={onUploadClick || (() => {})}
                onAddAccountClick={() => {}}
              />
            ) : (
              <LoginArea className="max-w-32" />
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
